import React, { Component } from 'react';
import { get, post, sess_get, sess_post, sess_put } from '../../utils/HttpRequests';
import { Modal, Button, Form } from 'react-bootstrap';
import moment from 'moment'
import { CSVReader } from 'react-papaparse'
import '../../assets/styles/modal.css'
const crossImg = require('../../assets/cross.svg')

let defaultState = {
    numbers: [],
    userMessage: '',
}

class AddNumberCSVModal extends Component {
    constructor(props) {
        console.log(props.close.toString())
        super(props);
        this.state = { ...defaultState };
    }

    handleClose = e => {
        e.preventDefault()
        this.props.close(false)
        this.setState(defaultState)
    }

    handleSubmit = async e => {
        e.preventDefault()
        const session_token = localStorage.getItem("admin-panel-sessionToken");
        return sess_post(`admin/console/add-numbers-to-coupon?id=${this.props.id}`, session_token, { numbers: this.state.numbers })
            .then((response) => {
                return this.props.close(true)
            }).catch(e => {
                this.setState({ userMessage: e.toString() })
            })
    }

    handleOnDrop = (data) => {
        try {
            data = data.map(item => {
                return item.data[0]
            })
            data = data.filter(d => (d + '').length == 10)
            console.log(data)
            if (data && data.length) {
                this.setState({
                    numbers: data
                })
            } else {
                this.setState({
                    numbers: [],
                    userMessage: 'Please enter a valid CSV'
                })
            }
        } catch (e) {
            this.setState({
                numbers: [],
                userMessage: 'Please enter a valid CSV'
            })
        }

    }

    handleOnRemoveFile = () => {
        this.setState({
            numbers: [],
            userMessage: ''
        })
    }

    render() {
        return (
            <Modal show={this.props.show} centered>
                <img className='cross-button' src={crossImg} onClick={this.handleClose} />
                <CSVReader
                    onDrop={this.handleOnDrop}
                    // onError={this.handleOnError}
                    addRemoveButton
                    removeButtonColor='#659cef'
                    onRemoveFile={this.handleOnRemoveFile}
                >
                    <span>Drop CSV file here or click to upload.</span>
                </CSVReader>

                <Button disabled={!(this.state.numbers && this.state.numbers.length)} type="submit" onClick={this.handleSubmit} color="primary" style={{ float: "left" }} className="kyc-filter-button">
                    Upload CSV Report
                </Button>
                <span className='user-Message'>{this.state.userMessage || ' '}</span>
            </Modal>
        )
    }
}




export default AddNumberCSVModal;